// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

export function toChromosomeId(input: string): number | null {
  if (!input) {
    return null;
  }
  for (const regex of [
    /^chr(\d+?|x|y)_/i,
    /chr(\d+|x|y)/i,
    /_ALT_REF_LOCI_(\w+)/,
    /chr\s+(\d+?|x|y)_/i,
    /chr_(\d+?|x|y)_/i,
    /chromosome\s+(\d+|\w+)/i,
  ]) {
    const m = input.match(regex);
    if (m?.length === 2) {
      const t = m[1].toLowerCase();
      if (t === 'x') {
        return 23;
      }
      if (t === 'y') {
        return 24;
      }
      const n = parseInt(m[1], 10);
      if (!Number.isNaN(n)) {
        return n;
      }
    }
  }
  return null;
}

export function toChromosomeName(id: string | number): string {
  const n = typeof id === 'string' ? Number(id) : id;
  if (Number.isInteger(n)) {
    if (n === 23) {
      return 'X';
    }
    if (n === 24) {
      return 'Y';
    }
    return String(n);
  }
  return String(id);
}

export function parseChromosome(input: string): number | string {
  const id = toChromosomeId(input);
  return id ?? input;
}

export const ChromosomeUtil = {
  toId: toChromosomeId,
  toName: toChromosomeName,
  parse: parseChromosome,
} as const;
